namespace $.$$ {
	export class $shm_showcase_demo_list_page extends $.$shm_showcase_demo_list_page {
		@ $mol_mem
		add_handler() { return ()=> this.add_item() }
		@ $mol_action
		add_item() { this.items( [ ...this.items(), `Элемент ${ this.items().length + 1 }` ] ) }
		rows() {
			return this.items().filter( item => item.toLocaleLowerCase().includes( this.filter().toLocaleLowerCase() ) )
				.sort( ( a, b )=> a.localeCompare( b, 'ru' ) * ( this.sort_order() === 'desc' ? -1 : 1 ) )
				.map( item => this.Row( item ) )
		}
		row_title( id: string ) { return id }
	}
}
